<ng-container *ngIf="entity">
  <div class="table mt-0100"
       *ngIf="entity.entityType.dateOfBirthEnabled">
    <div class="tr tr--noGutter tile__heading pt-0 pb-0">
      Age &amp; DOB
      <ng-container *ngIf="showTaskDoneMark">
        <span class="color--gray ml-0050">
          &bull;
          <span class="color--green">
            <span class="d-none d-inline--md uppercase ml-0025">Done</span>
            <i class="far fa-check ml-0025"></i>
          </span>
        </span>
      </ng-container>
      <button *ngIf="!readonly"
              mat-button
              disableRipple
              class="addNew ml-auto mat-button--no-focus-overlay"
              type="button"
              aria-label="Edit Date of Birth"
              (click)="openEditDobDialog()">
        <i class="far fa-pencil addNew__icon"></i>
        EDIT
      </button>
    </div>
    <div class="tr tr--noGutter pt-0025">
      <div class="tc tc--80">
        <div class="row row--left fb--baseline recap w-100">
          <ng-container *ngIf="entity.entityType.dateOfBirthEnabled">
            <div class="recap__label">DOB</div>
            <div class="recap__value">
              <i *ngIf="!entity.dateOfBirth || entity.calculatedBirthDate"
                 class="fal fa-minus color--gray--04"></i>
              <span *ngIf="entity.dateOfBirth && !entity.calculatedBirthDate">
                {{entity.dateOfBirth | date:'mediumDate'}}</span>
            </div>
            <div class="recap__label">AGE</div>
            <div class="recap__value">
              <i *ngIf="!entity.age && !entity.dateOfBirth"
                 class="fal fa-minus color--gray--04"></i>
              <span *ngIf="entity.age">
                {{entity.age}} years old
              </span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
